module.exports = __webpack_public_path__ + "static/media/portfolio-example-06.b05206fc.jpg";